<template>
  <div>
    <p class="auth-head">
      {{head}}
      <span class="auth-head-span">Re</span>Solved
      <span class="auth-span-tm">TM</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    head: String,
    optionText: String
  }
};
</script>

<style scoped>
.auth-head {
  font-family: "OpenSans-SemiBold";
  font-size: 30px;
  line-height: 41px;
  margin-top: 65px;
  text-align: center;
  padding: 0 20px;
}
.auth-head-span {
  font-size: 30px;
    line-height: 41px;
  color: #eddb51;
}

.auth-span-tm {
  font-size: 10px;
  position: absolute;
  font-family: "OpenSans";
  line-height: 20px;
}

.auth-input-section {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>